import { useAppSelector } from "@app/hooks/reduxHooks";
import ShortcutMenuWrapper, { MenuDetailsProps } from "../ShortcutNavigator/ShortcutMenuWrapper";
import { useState } from "react";
import ReportingMenuIcon from "assets/menus/temp/category.svg";
import ReportingHeaderIcon from "assets/menus/temp/reporting.svg";

export const ReportCategories: React.FC = () => {
    const { reportMenus } = useAppSelector((state) => state);
    const [menuItems, setMenuItems] = useState<MenuDetailsProps[]>([]);
    let formattedMenuItems: MenuDetailsProps[] = [];
    if (reportMenus && reportMenus.reportMenus) {
        formattedMenuItems = reportMenus.reportMenus.map((reportMenu): MenuDetailsProps => ({
            title: reportMenu.name,
            icon: ReportingMenuIcon,
            url: `/reports/${reportMenu.Id}`,
            categoryIcon: ReportingMenuIcon,
        }));

        //setMenuItems(formattedMenuItems);
    }

    return (
        <ShortcutMenuWrapper 
            title="shortcutMenus.reporting.title"
            icon={ReportingHeaderIcon}
            menus={formattedMenuItems}
        />
    );
}